import {inject, Injectable, signal} from '@angular/core';
import {OutOfStockDto} from "@dtos/status-dtos/out-of-stock-dto";
import {environment} from '@envs/environment';
import {LoggerService} from "./logger.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {takeUntilDestroyed, toObservable} from "@angular/core/rxjs-interop";
import {StoreAssignmentService} from "@services/store-assignment.service";
import {RequestHandlerService} from "@services/request-handler.service";

@Injectable({
    providedIn: 'root'
})
export class InventoryService {
    private _baseUrl = environment.apiUrl + 'status/v1/';
    private readonly _http = inject(HttpClient);
    private readonly _logger = inject(LoggerService);
    private readonly _storeAssignmentService = inject(StoreAssignmentService);
    private readonly _req = inject(RequestHandlerService);

    isLoadingOutOfStockItems = signal(false);
    outOfStockItems = signal<OutOfStockDto[]>([]);

    constructor() {
        toObservable(this._storeAssignmentService.assignableStores)
            .pipe(takeUntilDestroyed())
            .subscribe(async storeNames => {
                this._logger.debug('InventoryService -- got new store assignment from selected address service:', storeNames);
                await this.loadOutOfStockItems(storeNames);
            });
    }

    async loadOutOfStockItems(storeNames: string[] | undefined) {
        if (!storeNames?.length) {
            this.outOfStockItems.set([]);
            return;
        }

        this._logger.debug('InventoryService -- updating out of stock items. stores = ', storeNames);

        let params = new HttpParams();
        for (const store of storeNames) {
            params = params.append('stores', store);
        }

        const request = this._http.get<OutOfStockDto[]>(this._baseUrl + 'OutOfStock', {params});
        const response = await this._req.requesterHandler<OutOfStockDto[]>(request, this.isLoadingOutOfStockItems);
        if (response.type === 'error') {
            this.outOfStockItems.set([]);
            return;
        }

        this.outOfStockItems.set(response.data);
        this._logger.debug('InventoryService -- emitted out of stock items', response.data);
    }
}
